<template>

    <div class="overflow-auto">

        <transition name="router-anim">
            <v-container class="d-flex flex-column align-center justify-center container-main">
                <v-card class="d-flex flex-column rounded-xl" width='400'>

                    <v-card-text class="d-flex align-center justify-center card-img">
                        <v-img class="logo" max-width="200" max-height="200" alt="logo" src="../../../assets/register-account-logo.jpg">

                        </v-img>
                    </v-card-text>

                    <v-form class="form-provider rounded" v-model="valid">

                        <v-container>

                            <v-row class="d-flex justify-center align-center mt-n9">
                                <p class="text-welcome">{{$t('account_register.welcome')}}</p>
                            </v-row>

                            <v-row>
                                <v-col cols="12" md="12">
                                    <v-text-field class="field-name" outlined v-model.trim="form.name" :disabled="loading" :rules="nameRules" :label="'* ' + $t('fields.user_name.label')" :placeholder="$t('fields.user_name.placeholder')" append-icon="mdi-account" required />
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12">
                                    <v-text-field class="field-email" outlined v-model.trim="form.email" type="email" :disabled="loading" :rules="emailRules" :label="'* ' + $t('fields.user_email.label')" :placeholder="$t('fields.user_email.placeholder')" append-icon="mdi-email" required />
                                </v-col>
                                <v-col cols="12">
                                    <v-text-field class="field-password" outlined v-model="form.password" :type="showPassword ? 'text' : 'password'" :rules="passwordRules" :label="'* ' + $t('fields.password.label')" :placeholder="$t('fields.password.placeholder')" :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'" :disabled="loading" @click:append="showPassword = !showPassword" counter required />
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" md="12" class="d-flex col-phone">
                                    <CountryNumber class="field-number" idInput='1' @input1='phoneEvent($event)' :rules="['required', 'min']" v-bind:phoneNumber='form.phone' :label="$t('fields.phone.label')" />
                                </v-col>
                            </v-row>

                        </v-container>

                        <p class="caption">{{ $t('account_register.checkout_explain')}}</p>

                        <v-btn block rounded :disabled="!valid || loading" :loading="loading" color='#4ec5c1' class="white--text btn-send" @click="registerClick">
                            {{ $t('account_register.checkout') }}
                        </v-btn>

                    </v-form>

                    <v-btn to='/account-home' fab top left absolute class="mt-8" icon>
                        <v-icon>mdi-arrow-left</v-icon>
                    </v-btn>
                </v-card>

            </v-container>

        </transition>

    </div>

</template>

<script>

import validators from '../../../utils/validators'; 
import { mask } from 'vue-the-mask' 
import { mapActions } from 'vuex';
import { CREATE_ACCOUNT } from '../../../store/mutations';
import CountryNumber from '../../components/utils/CountryNumber.vue';

export default {

    components: { CountryNumber },

    name: 'RegisterAccount',

    directives: { mask },

    data() {

        return {

            showPassword: false,
            loading: false,
            valid: true,
            nameRules: [
                v => validators.name.required(v) || this.$t('validators.name.required'),
            ],
            emailRules: [
                v => validators.email.required(v) || this.$t('validators.email.required'),
                v => validators.email.invalid(v) || this.$t('validators.email.invalid'),
            ],
            phoneRules: [
                v => validators.phone.only_numbers(v) || this.$t('validators.phone.only_numbers'),
                v => validators.phone.min_length(v) || this.$t('validators.phone.min_length'),
            ],
            passwordRules: [
                v => validators.password.required(v) || this.$t('validators.password.required'),
                v => validators.password.min_length(v) || this.$t('validators.password.min_length', [7]),
            ],

            form: {

                name: '',
                email: '',
                password: '',
                phone: '',

            }
        }
    },

    methods: {

        ...mapActions({ createAccount: `AccountVuex/${CREATE_ACCOUNT}` }),

        phoneEvent(event) {

            return this.form.phone = event

        },

        async registerClick() {

            this.loading = true;

            this.showToast(this.$t('redirect'),  this.$t('plans'), 'info')

            try {

                const accountData = await this.createAccount(this.form)

                const f = document.createElement('form');
                f.action = accountData.redirectURL;
                f.method = 'POST';

                const i = document.createElement('input');
                i.type = 'hidden';
                i.name = 'token';
                i.value = accountData.token;
                f.appendChild(i);

                document.body.appendChild(f);

                return f.submit();

            } catch (error) {

                this.loading = false;

                return this.showToast(error.message, this.$t('user_register.toast_error_update_title'), 'error')


            } 
        },

    },

    created() {

        


    },

}
</script>

<style lang="scss" scoped>

.welcome-dialog {
    width: 90%;
    background: linear-gradient(270deg, rgba(255, 255, 255, 0) 2.59%, #FFEBDD 61.46%), #FAF7F2;
    box-shadow: 0px 5px 6px rgba(0, 0, 0, 0.2), 0px 3px 16px rgba(0, 0, 0, 0.12), 0px 9px 12px rgba(0, 0, 0, 0.14);
    border-radius: 30px;
    max-width: 900px;
    margin-bottom: 5%;
}
.logo {

    height: 100%;

}

.form-provider {
    width: 100%;
    height: 100%;
    padding: 20px;
    overflow: auto;
    text-align: center;
}

.text-welcome {
    font-style: italic;
    font-weight: 800;
    font-size: 95%;
    text-align: center;
    line-height: 20px;
    color: var(--blue-qi);
}

</style>